var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b_w"},[_c('headTop',{attrs:{"head-title":"出售记录","go-user":"true"}}),_vm._v(" "),_c('list',{ref:"list",attrs:{"list":_vm.list,"type":2,"sta":_vm.sta},on:{"scrollToEnd":_vm.scrollToEnd,"pulldown":_vm.pulldown}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dfe88a7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/record/selllist.vue
// module id = 529
// module chunks = 13